module.exports = __webpack_public_path__ + "static/media/wukong.cc967b27.png";